import types from './types';
import actions from './actions';
import reducers from './reducers';
import services from './services';

const products = {
  types,
  actions,
  reducers,
  services,
}

export default products;